export default "__VITE_ASSET__BL4Hk$h2__"